import axios from "axios";
import { toastr } from "react-redux-toastr";

import config from "../../config/constants";
import {
  loadProcessToken,
  getImportStatus,
  showErrorToaster,
} from "./index";

export const ASSETS_LOADING = 'ASSETS_LOADING';
export const LOAD_ASSETS = 'LOAD_ASSETS';
export const CREATE_ASSET = 'CREATE_ASSET';
export const UPDATE_ASSET = 'UPDATE_ASSET';
export const DELETE_ASSET = 'DELETE_ASSET';
export const OPEN_ASSET = 'OPEN_ASSET';
export const ASSETS_IMPORT_STATUS = 'ASSETS_IMPORT_STATUS';

const assetsListLoading = payload => ({
  type: ASSETS_LOADING,
  payload,
});

export const loadAssets = (props = {}, scope) => (dispatch, getState) => {
    const token = loadProcessToken();
    dispatch(assetsListLoading(true));
    const page = props && props.page ? props.page + 1 : 1;
    const perPage = props && props.perPage ? props.perPage : 20;
    const filterFieldData =
      props && props.filterFieldData
        ? props.filterFieldData.trim() : '';

    const sortBy = props && props.sortBy ? props.sortBy : '';

    axios.get(
      config.API_URL + 'ai4ai/entities/asset?' + filterFieldData +
      '&page=' + page + '&per_page=' + perPage +
      ( sortBy && sortBy.length > 0 ? '&sort_by=' + sortBy : '' )
    )
      .then(({ data }) => {
        if (data){
          dispatch({
            type: LOAD_ASSETS,
            payload: data
          });
          dispatch(assetsListLoading(false));
        }
      })
      .catch(function (error) {
        showErrorToaster(error, "Unknown Error in retrieving assets", "Please refer the console logs for more details on the error.");
      });
};

export const createOrUpdateAsset = (props, history) => (dispatch, getState) => {
  let token = loadProcessToken();
  if(props._id) {
    axios.put(config.API_URL + 'ai4ai/entities/asset', props)
      .then(({ data }) => {
        dispatch({
          type: UPDATE_ASSET,
          payload: data.data
        });
        history.push('asset_management');
        toastr.success('Successfully update the Asset');
      }).catch(function (error) {
        showErrorToaster(error, "Unknown Error in updating asset", "Please refer the console logs for more details on the error.");
      });
  } else {
    return axios.post(config.API_URL + 'ai4ai/entities/asset', props)
      .then(({ data }) => {
        dispatch({
          type: CREATE_ASSET,
          payload: data.data
        });
        history.push('asset_management');
        toastr.success('Successfully created the Asset');
      }).catch(function (error) {
        showErrorToaster(error, "Unknown Error in creating asset", "Please refer the console logs for more details on the error.");
      });
  }
};

export const deleteAsset = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  return axios.delete(config.API_URL + 'ai4ai/entities/asset/' + props._id)
    .then(({ data }) => {
      dispatch({
        type: DELETE_ASSET,
        payload: props._id
      });
      toastr.success('Successfully deleted the asset');
    }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in deleting asset", "Please refer the console logs for more details on the error.");
    });
};

export const openAsset = payload => (dispatch, getState) => {
  dispatch({
    type: OPEN_ASSET,
    payload,
  });
};

export const onAssetImport = (props, scope) => (dispatch, getState) => {
  const token = loadProcessToken();
  let formData = new FormData();
  formData.append('data_file', props.file);

  axios.post(
    config.API_URL + 'ai4ai/entities/bulk_import/asset',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }
  ).then(response => {
    response = response.data;
    if (response){
      localStorage.setItem('fetchImportStatus', true);
      dispatch(getImportStatus(response.data._id, ASSETS_IMPORT_STATUS));
    }
  }).catch(function (error) {
    showErrorToaster(error, "Unknown Error in importing assets", "Please refer the console logs for more details on the error.");
  });
};

export const stopFetchingImportAssetsStatus = () => (dispatch, getState) => {
  localStorage.removeItem('fetchImportStatus');
};

export const deleteAssetsImportStatus = () => (dispatch, getState) => {
  dispatch({
    type: ASSETS_IMPORT_STATUS,
    payload: {},
  });
};
